import { Box } from '@mui/material';
import { ActivityHeaderSectionLayout } from 'modules/components/layer31';
import React, { ReactNode } from 'react';



export type ActivityHeaderSectionWithSearchLayoutProps = {
  searchBar: ReactNode;
  title?: string;
  actionButtons?: ReactNode | ReactNode[];
  subtitle?: string;
  backButton?: ReactNode;
  overideReturnPath?: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityHeaderSectionWithSearchLayoutProps) => {
  return (
    <ActivityHeaderSectionLayout.FC
      title={props.title}
      subtitle={props.subtitle}
      actionButtons={props.actionButtons}
      backButton={props.backButton}
      overideReturnPath={props.overideReturnPath}
    >
      {/* SearchBard Section */}
      <Box
        flex='1 1 0'
      >
        {props.searchBar}
      </Box>
    </ActivityHeaderSectionLayout.FC>
  );
};
